import { KioskEntryMessageBoxStyled } from '../Kiosk.styled';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { KioskLayoutWithResetKioskButton } from '../KioskLayoutWithResetKioskButton';
import { KioskTextInput } from './KioskTextInput';
import { KioskTextInputHintWrap } from './KioskInputHynt';

export const KioskUpdateUser = ({
  onUpdateUser,
  onExitClicked,
}: {
  onUpdateUser: (userInput: string) => any;
  onExitClicked: () => any;
}) => {
  const { t } = useCommonTranslation();

  return (
    <KioskLayoutWithResetKioskButton onExitClicked={onExitClicked}>
      <KioskEntryMessageBoxStyled>
        <KioskTextInputHintWrap inputHint={t('kiosk-update-user-hint')}>
          <KioskTextInput
            onInputSubmit={onUpdateUser}
            maxLength={15}
            minLength={3}
            uppercase={false}
          />
        </KioskTextInputHintWrap>
      </KioskEntryMessageBoxStyled>
    </KioskLayoutWithResetKioskButton>
  );
};
